import React from 'react';
// import { FaqPage } from '@desquared/wave-components-library';
import cn from 'classnames';
import styles from './FaqPage.module.css';
import {
  AccordionList,
  CorporateContent,
  Heading,
  HeadingEnum,
  Text,
  TextEnum,
  BoldEnum,
} from '@desquared/wave-components-library';
import { setFaqs } from '@/utils/corporateUtils';
export default function FaqPageSection(props) {
  let image = undefined;
  if (props.faqs.included.corporate_content[0].content.image) {
    image = props.faqs.included.corporate_content[0].content.image.url;
  }
  const faqIds = props.faqs.data[0].content.faq.map(item => item.id);

  // Sort included.faqs based on the order of faqIds
  const sortedFaqs = faqIds.map(id => props.faqs.included.faqs.find(faq => faq.id === id));

  // Update the data object with the sorted faqs
  const sortedData = {
    ...props.faqs.data,
    included: {
      ...props.faqs.included,
      faqs: sortedFaqs,
    },
  };

  return (
    <section className={cn(styles.layout)}>
      <Heading type={HeadingEnum.HeadingL} bold={BoldEnum.Bold}>
        {props?.faqs?.data[0].content.title}
      </Heading>
      {props?.faqs?.data[0].content.subtitle && (
        <Text type={TextEnum.SubHeading3} bold={BoldEnum.Medium}>
          {props?.faqs?.data[0].content.subtitle}
        </Text>
      )}
      {props?.faqs?.included?.corporate_content?.length > 0 &&
        props?.faqs?.included?.corporate_content[0]?.content?.title && (
          <CorporateContent
            img={image}
            imgTitle={props.faqs.included.corporate_content[0].content.title}
            buttonText={props.faqs.included.corporate_content[0].content.buttonText}
          >
            {props.faqs.included.corporate_content[0].content.description && (
              <div
                dangerouslySetInnerHTML={{ __html: props.faqs.included.corporate_content[0].content.description }}
              ></div>
            )}
          </CorporateContent>
        )}
      {sortedData.included.faqs &&
        sortedData.included.faqs.map((item, index) => (
          <AccordionList title={item.content.title} faqs={setFaqs(item.content.simple_faq)} key={index} />
        ))}
    </section>
  );
}
